import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Center,
  Code,
  Divider,
  Heading,
  Link,
  Text,
  VStack,
} from "@chakra-ui/react";

import { Layout } from "./PageLayouts";

export function NotFoundPage() {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <Layout variant="centered" align="center">
      <Card>
        <CardHeader as={VStack}>
          <Heading size="lg">Uh oh!</Heading>
          <Heading size="md">
            It looks like this page doesn&apos;t exist!
          </Heading>
        </CardHeader>
        <Center>
          <Divider width="95%" />
        </Center>
        <CardBody as={VStack} textAlign="center">
          <Text>
            We can&apos;t find the page <Code>{location.pathname}</Code>!
          </Text>
          <Text>
            If you think this page is missing, double check the URL, and then
            email
            <Link
              marginLeft="0.25rem"
              marginRight="0.25rem"
              href="mailto:support@ccv.brown.edu"
            >
              CCV Support
            </Link>
            !
          </Text>
          <Button variant="primary" onClick={() => navigate("/")}>
            Go Home
          </Button>
        </CardBody>
      </Card>
    </Layout>
  );
}
